module.exports = __webpack_public_path__ + "img/passport-stamps-1.91df45b2.jpg";